import io from 'socket.io-client';
import auth from '@/service/auth'
import config from '../config'

function getApiHost() {
  if(location.hostname == 'localhost') { return config.baseWS; }
  switch(process.env.NODE_ENV) {
    case 'development' : return config.baseWS;
    default : return `${location.protocol}//${location.hostname.replace(/^[^\.]*\./, 'ws.')}`;
  }
}
const baseUrl = getApiHost();

let _socket = undefined;

let start = () => {
  if(_socket && !_socket.disconnected) { return _socket; }
  _socket = io(baseUrl, { query : { token : auth.token } })
  .on('connection', s => console.log("new connection", s))
  .on('error', e => { if(e === 'invalid token') { this.toastr.error('session expired due to invalid token.'); } })
  .on('reconnect_attempt', (n) => { _socket.io.opts.query.token = auth.token; console.log(n, "eeee")})
  return _socket;
}
let stop = () => {
  if(_socket) { _socket.disconnect(); _socket = undefined; }
}

const rv = {
  open : start,
  close : stop,
  socket: () => _socket
};
export default rv

if(location.hostname == 'localhost') { window['socket'] = rv; }
